const LegalEntityErrorCodes = {
  LET00001: 'legal entity not found',
} as const;

export default LegalEntityErrorCodes;
